import React, { useState } from "react";
import dummyImg from "../../images/no-image-thumb.jpg";

const StatusAccordion = ({ data }) => {
  const statusGroups = Object.values(data.status_groups || {});
  const lastCommentIndex = [...statusGroups]
    .reverse()
    .findIndex((g) => g.comments);
  const defaultCommentIndex =
    lastCommentIndex === -1 ? -1 : statusGroups.length - 1 - lastCommentIndex;
  const [selectedCommentIndex, setSelectedCommentIndex] =
    useState(defaultCommentIndex);

  const getActiveStepWidth = () => {
    const total = statusGroups.length;
    const currentIndex = statusGroups.findIndex(
      (group) => group.id === data.current_status_id
    );
    return currentIndex > 0 ? (currentIndex / (total - 1)) * 100 : 0;
  };

  // Flag to control assigning classes only before current_status_id
  let afterCurrentStatus = false;

  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id={`heading-${data.id}`}>
        <button
          className="accordion-button"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#collapse-${data.id}`}
          aria-expanded="true"
          aria-controls={`collapse-${data.id}`}
        >
          <div className="mask-container">
            <img
              src={data?.image || dummyImg} // Use default image if `data.image` is null/undefined
              alt="apartment"
              className="target-image"
              onError={(e) => {
                e.target.onerror = null; // Prevent infinite loop
                e.target.src = dummyImg; // Use fallback if image fails to load
              }}
            />
          </div>
          <div className="prophead">
            <span className="propnam">{data?.title}</span>
            <span className="adedtime">{data?.created_at}</span>
          </div>
          <div className="mypropval-status">{data?.current_status}</div>
        </button>
      </h2>
      <div
        id={`collapse-${data.id}`}
        className="accordion-collapse collapse show"
        aria-labelledby={`heading-${data.id}`}
        data-bs-parent="#accordionExample"
      >
        <div className="accordion-body">
          <h5 className="mob text-center mt-3">{data?.title}</h5>
          <div className="trackstatus">
            <div className="stepbarbx">
              <div className="stepbarbase"></div>
              <div
                className="activestepbar"
                style={{
                  width: `${
                    getActiveStepWidth() === 0 ? 100 : getActiveStepWidth()
                  }%`,
                  backgroundColor:
                    getActiveStepWidth() === 0
                      ? "#ccc" // Gray for step 0
                      : "#0f7501", // Green for full progress
                }}
              ></div>

              {/* Stage Rendering */}
              {statusGroups && statusGroups.length > 0 ? (
                statusGroups.map((group, gIndex) => {
                  const leftPercent = `${
                    (gIndex / (statusGroups.length - 1)) * 100
                  }%`;
                  const isTop = gIndex % 2 === 0 ? "topone" : "botone";

                  let statusClass = "";
                  const isActive = !!group.comments;

                  if (!afterCurrentStatus) {
                    if (data?.current_status_id === group?.id) {
                      statusClass = "active";
                      afterCurrentStatus = true; // All future ones get no class
                    } else {
                      statusClass = isActive ? "preactive" : "";
                    }
                  }

                  return (
                    <div
                      key={gIndex}
                      className={`stages stage${
                        gIndex + 1
                      } ${isTop} ${statusClass} ${
                        selectedCommentIndex === gIndex ? "selected" : ""
                      }`}
                      style={{ left: `calc(${leftPercent} - 100px)` }}
                      onClick={() =>
                        isActive && setSelectedCommentIndex(gIndex)
                      }
                    >
                      <div className="trackcircle"></div>
                      <p>{group.status}</p>
                    </div>
                  );
                })
              ) : (
                <p>No status groups found</p>
              )}
            </div>
          </div>

          {/* Comments Section */}
          <div className="cmnt">
            <svg width="14" height="14" viewBox="0 0 20 20" fill="none">
              <g clipPath="url(#clip0_917_4)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15 7.5C14.31 7.5 13.75 8.06 13.75 8.75C13.75 9.44 14.31 10 15 10C15.69 10 16.25 9.44 16.25 8.75C16.25 8.06 15.69 7.5 15 7.5ZM10 16.25C9.27 16.25 8.565 16.165 7.8875 16.0206L4.945 17.7894L4.98438 14.89C2.72875 13.5338 1.25 11.2912 1.25 8.75C1.25 4.60813 5.1675 1.25 10 1.25C14.8325 1.25 18.75 4.60813 18.75 8.75C18.75 12.8925 14.8325 16.25 10 16.25ZM10 0C4.4775 0 0 3.91813 0 8.75C0 11.5119 1.46563 13.9713 3.75 15.5744V20L8.13063 17.3419C8.73688 17.4419 9.36062 17.5 10 17.5C15.5225 17.5 20 13.5825 20 8.75C20 3.91813 15.5225 0 10 0ZM5 7.5C4.31 7.5 3.75 8.06 3.75 8.75C3.75 9.44 4.31 10 5 10C5.69 10 6.25 9.44 6.25 8.75C6.25 8.06 5.69 7.5 5 7.5ZM10 7.5C9.31 7.5 8.75 8.06 8.75 8.75C8.75 9.44 9.31 10 10 10C10.69 10 11.25 9.44 11.25 8.75C11.25 8.06 10.69 7.5 10 7.5Z"
                  fill="#343434"
                />
              </g>
              <defs>
                <clipPath id="clip0_917_4">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <p
              className={`comment-text ${
                selectedCommentIndex !== -1 ? "fade-in" : "fade-out"
              }`}
            >
              {selectedCommentIndex !== -1 &&
              statusGroups[selectedCommentIndex]?.comments
                ? statusGroups[selectedCommentIndex].comments
                : "No comments available"}
            </p>
            {data?.valuation && (
              <span style={{ fontSize: "12px", color: "#343434", marginLeft:'10px', fontWeight:'600' }}>
                Estimated value - ₹{data.valuation}
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusAccordion;
